import { formatWithCommasOrExponential } from 'common/utils/chart/chartUtils'

// Helper functions to reduce nesting in MutationObserver
export function formatWallThickness(node: ChildNode) {
  const wallThickness = node.lastChild?.textContent

  if (wallThickness) {
    const [integers, decimals = ''] = wallThickness.trim().split('.')
    const formattedDecimals = decimals.padEnd(3, '0')
    node.lastChild.textContent = `${integers}.${formattedDecimals}`
  }
}

export function formatDate(node: ChildNode) {
  const text = node.lastChild?.textContent

  if (text) {
    const [month, day, year] = text.split(',')[0].split('/')

    node.lastChild.textContent =
      `${year}-${String(month).padStart(2, '0')}` +
      `-${String(day).padStart(2, '0')}`
  }
}

export function formatRiskValue(node: ChildNode) {
  const riskValue = node.lastChild?.textContent

  if (riskValue) {
    const riskValueNoComma = riskValue?.replace(/,/g, '')

    node.lastChild.textContent = formatWithCommasOrExponential(
      riskValueNoComma,
      { isMeasure: false }
    )
  }
}

export const formatTableNode = (node: ChildNode) => {
  const label = node.firstChild?.textContent?.trim()

  if (label?.endsWith('Wall Thickness')) {
    formatWallThickness(node)
  }

  if (label?.endsWith('Date')) {
    formatDate(node)
  }

  if (label === 'Total Risk' || label === 'Risk Density') {
    formatRiskValue(node)
  }
}
